
import times from './times'
import ProcessTimeSlots from './ProcessTimeSlots'
import pipe from './pipe'
import pile from './pile'
import dayjs from './dayjs'
import classNames from 'classnames'
import { v4 as uuid } from 'uuid';

function defer() {
    let resolve;
    let reject;
    let promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve
        reject = _reject
    })
    promise.resolve = resolve;
    promise.reject = reject;
    return promise
}
function arrayToJSONByID(data){
    let _data = {}
    if(Array.isArray(data)){
        _data = {}
        data.forEach((value)=>{
            _data[value.id] = value
        })
    } else {
        _data = data
    }
    return _data;
}
function isOrganizationIntegrated(organization){
    for(let integration of Object.values(organization.integrations)){
        if(integration.pim == true && integration.active == true) return true
    }
    return false
}
function formatPhoneNumber(value){
    value = value.replace(/\D/g, '')
    value = value.split('')
    
    if(value.length > 3){
        value.splice(3, 0, '-')
    }
    
    if(value.length > 7){
        value.splice(7, 0, '-')
    }
    
    return value.join('')
}
export {
    times,
    ProcessTimeSlots,
    pipe,
    pile,
    uuid,
    dayjs,
    classNames,
    defer,
    arrayToJSONByID,
    isOrganizationIntegrated,
    formatPhoneNumber
}


// WEBPACK FOOTER //
// ./lib/helpers/index.js